import { BaseClient } from '../base-client';
import type {
  ListUserEmployeeCostsQuery,
  SetUserEmployeeCostInput,
  UserEmployeeCost,
} from './types';

type One = { data: UserEmployeeCost };
type ListResponse = {
  data: UserEmployeeCost[];
  meta: { total: number; limit: number; offset: number };
};

export class UserEmployeeCostsClient extends BaseClient {
  /**
   * Full cost history for `userId`. With `asOf`, returns the single
   * row in effect on that date (wrapped in `data` so callers can treat
   * both response shapes the same).
   */
  list(query: ListUserEmployeeCostsQuery): Promise<ListResponse> {
    return this.request('/api/user-employee-costs', { query: normalize(query) });
  }

  /**
   * Record a new cost effective at `effectiveFrom`. The server splits
   * the prior open/containing period and inserts the new row in one
   * transaction — clients see a single returned row.
   */
  set(input: SetUserEmployeeCostInput): Promise<One> {
    return this.request('/api/user-employee-costs', { method: 'POST', body: input });
  }
}

function normalize(q: object): Record<string, string | number | boolean | undefined> {
  const out: Record<string, string | number | boolean | undefined> = {};
  for (const [k, v] of Object.entries(q)) {
    if (v === undefined || v === '') continue;
    if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') {
      out[k] = v;
    }
  }
  return out;
}
